import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=dffb9f58&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=dffb9f58&prod&lang=scss&scoped=true"
import style1 from "./editor.vue?vue&type=style&index=1&id=dffb9f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffb9f58",
  null
  
)

export default component.exports